export interface Destination {
  id: string;
  name: string;
  subtitle: string;
  image: string;
  alt: string;
  properties: number;
  span?: string;
}

export const DESTINATIONS: Destination[] = [
  {
    id: 'dest-algiers',
    name: 'Algiers',
    subtitle: 'The White City',
    image: 'https://images.unsplash.com/photo-1671222842347-d43c51c17bb8',
    alt: 'Algiers white buildings cascading down to the Mediterranean sea at golden hour',
    properties: 148,
    span: 'col-span-2 row-span-2',
  },
  {
    id: 'dest-oran',
    name: 'Oran',
    subtitle: 'City of Joy',
    image: 'https://images.unsplash.com/photo-1657700995354-d9d323732067',
    alt: 'Oran coastal city with colorful buildings and Mediterranean harbor',
    properties: 92,
  },
  {
    id: 'dest-constantine',
    name: 'Constantine',
    subtitle: 'City of Bridges',
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_110f73ce7-1776709888798.png',
    alt: 'Constantine ancient city perched on dramatic rocky gorges with suspension bridges',
    properties: 67,
  },
  {
    id: 'dest-sahara',
    name: 'Sahara',
    subtitle: 'The Golden Desert',
    image: 'https://images.unsplash.com/photo-1586012350366-1eea1beb846e',
    alt: 'Vast Saharan sand dunes glowing orange at sunset with camel silhouettes',
    properties: 34,
    span: 'col-span-2',
  },
];
